import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HighlightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"highlight"}/>
}
